<template>
  <div>
    <v-container>
      <DoctorFeatures />
    </v-container>

    <DoctorFooterBanner v-if="locale.isRu" />
  </div>
</template>

<script setup lang="ts">
import { generatePageMetaLinks } from '~/core/seo'
import DoctorFeatures from '~/features/Home/components/FeaturesSection/DoctorFeatures/DoctorFeatures.vue'
import DoctorFooterBanner from '~/features/Home/components/FeaturesSection/DoctorFeatures/DoctorFooterBanner.vue'

const locale = useAppLocale()

useHead({
  link: generatePageMetaLinks(),
})
</script>
